import * as types from './mutation_types'

export default {
  [types.EXABORGANIZATIONLEAD_DELETE_SET_DELETED] (state, deleted) {
    Object.assign(state, { deleted })
  },

  [types.EXABORGANIZATIONLEAD_DELETE_SET_ERROR] (state, error) {
    Object.assign(state, { error })
  },

  [types.EXABORGANIZATIONLEAD_DELETE_TOGGLE_LOADING] (state) {
    Object.assign(state, { isLoading: !state.isLoading })
  },

  [types.EXABORGANIZATIONLEAD_DELETE_RESET] (state) {
    Object.assign(state, {
      deleted: null,
      error: '',
      isLoading: false
    })
  }
}
